// extracted by mini-css-extract-plugin
export default {"AnnotationsList-Title":"AnnotationsList_AnnotationsList-Title__lRHOT"};